/* eslint-disable max-len */
/**
 * German translations.
 */
export default {
  ACTION: {
    LINK_COPY: 'Kopieren'
  },
  ERROR: {},
  HEADER: {
    NAME: 'Name',
    PROFIT_MARGIN: 'Provisionssatz'
  },
  LABEL: {
    GENERATE_LINK: 'Link generieren',
    GENERATED_LINK: 'Generierter Link',
    NAME: 'Name',
    PROFIT_MARGIN: 'Provisionssatz'
  },
  SENTENCE: {},
  SUCCESS: {
    LINK_COPIED: 'Link kopiert'
  },
  TOOLTIP: {
    NAME: 'Name',
    PROFIT_MARGIN: 'Provisionssatz'
  }
};
